import * as React from 'react'
const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={42} height={28} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M37.5 26.5V16M8 22h4m-4-5h4m-4-5h4M8 7h4m10.5 15H25m3.242-20v.864m-4.492.822.611.611M22 8.242h.864m9.886 4.444-.611-.61m2.233-3.834h-.864m-.758-4.556-.611.611M28.25 10.5a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5m6.785 7.528L37.5 20l2.465-1.972m-4.913 4.013L37.5 24l2.449-1.959M41 27H1m2 0V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v23"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 16h6a2 2 0 0 1 2 2v9"
    />
  </svg>
)
export default SvgComponent
